export const dateTimeLong = 'YYYY-M-D H:mm';
export const dateTimeLongFull = 'YYYY-MM-DD HH:mm';
export const dateLong = 'YYYY-MM-DD';
